import { render, staticRenderFns } from "./tableItems.vue?vue&type=template&id=d7324b54&scoped=true"
import script from "./tableItems.vue?vue&type=script&lang=js"
export * from "./tableItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7324b54",
  null
  
)

export default component.exports